import React from 'react';
import { PropertyAlertTriggersList } from '../property-alert-triggers-list';

export function PropertyAlertTriggers() {
  return <PropertyAlertTriggersList />;
}
